import { Stack, Typography } from "@mui/material";

import { StyledLabelStack, StyledUserBox } from "./styles";
import { UsersHookFormSelect } from "../UsersHookFormSelect";
import { HubHookFormSelect } from "../HubHookFormSelect";

const versions = [
  {
    id: 1,
    label: "V10 - Quoting Model",
  },
];

export const UnderlinedLabel = ({
  label = "",
  sublabel = "",
  underlined = true,
  c1 = "100px",
  value = "",
  userSignature = false,
  isField = false,
  ...rest
}) => {
  const valueSx = underlined ? { borderBottom: "1px solid" } : {};
  return (
    <StyledLabelStack c1={underlined ? "auto" : c1} {...rest}>
      <Typography variant="caption" fontWeight={400} fontSize={10}>
        {label}:
      </Typography>
      {isField ? (
        <StyledUserBox isUser={userSignature}>
          {userSignature ? (
            <UsersHookFormSelect
              name="createdById"
              label={null}
              defaultValue={value}
              shouldUnregister={false}
              CustomRenderValue={({ name }) => (
                <Typography
                  variant="signature"
                  fontSize="25px"
                  lineHeight="36px"
                  noWrap
                >
                  {name}
                </Typography>
              )}
              required
            />
          ) : (
            <HubHookFormSelect
              name="version"
              options={versions}
              defaultValue={1}
              shouldUnregister={false}
              required
            />
          )}
        </StyledUserBox>
      ) : (
        <Typography variant="signature" fontSize="25px" sx={valueSx} noWrap>
          {value}
        </Typography>
      )}
      <Typography variant="caption" />
      <Typography variant="caption" fontSize={10} alignSelf="start">
        {sublabel}
      </Typography>
    </StyledLabelStack>
  );
};

const SignatureSection = ({ createdById }) => (
  <Stack direction="row" alignItems="end" gap="15px">
    <UnderlinedLabel
      label="Approved By"
      sublabel="Authorized IPC Agent"
      value={createdById}
      userSignature
      isField
    />
    <UnderlinedLabel
      label="Quoting Framework"
      sublabel="Version used to generate quote"
      isField
    />
  </Stack>
);

export default SignatureSection;
